export default __webpack_public_path__ + "static/media/homeBg.ffd8e100.png";